module.exports = __webpack_public_path__ + "img/edit-form.0827445d.svg";